import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const ACTOR_COLORS = {
  "onb":            "#176736",
  "dreal":          "#0e4596",
  "edf":            "#ffcf31",
  "consumers":      "#c72f30",
  "elus-locaux":    "#205673",
  "agriculture":    "#ff5b2d",
  "petit-commerce": "#f85ca5",
  "grosse-industrie": "#65326b",
  "industry":       "#65326b",
  "agence-eau":     "#736e6a",
};

const CRISIS_ICONS = {
  popularity:     "⚠️",
  biodiversity:   "🌿",
  carbon_economy: "⚠️",
  economy:        "📉",
  water_quality:  "💧",
};

const ActorsBudgets = ({ actorsBudgets, handleNext, consequences, round, language }) => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (language) i18n.changeLanguage(language);
  }, [language, i18n]);

  const [happeningType, setHappeningType] = useState(null);

  useEffect(() => {
    if (round === 3) {
      const happening = consequences.find((c) => c.is_happening);
      if (happening) setHappeningType(happening.happening_category);
    }
  }, [JSON.stringify(consequences)]);

  const getCrisisText = (type) => {
    switch (type) {
      case "popularity":
        return [t("popularity-crisis-1"), t("popularity-crisis-2")];
      case "biodiversity":
        return [t("biodiversity-crisis-1"), t("biodiversity-crisis-2")];
      case "carbon_economy":
        return actorsBudgets.length > 6
          ? [t("carbon-crisis-1"), t("carbon-crisis-2")]
          : null;
      case "economy":
        return [t("economy-crisis-1"), t("economy-crisis-2")];
      case "water_quality":
        return [t("quality-crisis-1"), t("quality-crisis-2")];
      default:
        return null;
    }
  };

  const crisisText = happeningType ? getCrisisText(happeningType) : null;

  return (
    <div className="ab-page">

      <div className="ab-header">
        <span className="ab-header-icon">🗳️</span>
        <h2 className="ab-header-title">{t("actors-round-votes")}</h2>
      </div>

      <div
        className="ab-actors-grid"
        style={{ gridTemplateColumns: `repeat(${Math.ceil(actorsBudgets.length / 2)}, 1fr)` }}
      >
        {actorsBudgets.map((actor) => {
          const color = ACTOR_COLORS[actor.actor_id] || "#205673";
          const isLight = actor.actor_id === "edf";
          const isWhiteBadge = actor.actor_id === "elus-locaux";
          const badgeStyle = isWhiteBadge
            ? { backgroundColor: "white", color: "#205673", border: "2px solid #205673" }
            : { backgroundColor: color, color: isLight ? "#205673" : "white" };
          const voteIcon = isLight || isWhiteBadge ? "/vote-blue4.png" : "/vote-white4.png";
          return (
            <div className="ab-actor-card" key={actor.actor_id}>
              <div className="ab-actor-accent" style={{ backgroundColor: color }} />
              <div className="ab-actor-body">
                <p className="ab-actor-name">{actor.name}</p>
                <div className="ab-actor-votes" style={badgeStyle}>
                  <span className="ab-votes-count">{actor.budget}</span>
                  <img className="ab-vote-icon" src={voteIcon} alt="vote" />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {crisisText && (
        <div className="ab-crisis-alert">
          <span className="ab-crisis-emoji">{CRISIS_ICONS[happeningType]}</span>
          <div className="ab-crisis-text">
            <p>{crisisText[0]}</p>
            <p>{crisisText[1]}</p>
          </div>
        </div>
      )}

      <button className="ab-continue-btn" onClick={handleNext}>
        {t("Continuer")} →
      </button>

    </div>
  );
};

export default ActorsBudgets;
